<template>
  <v-dialog :value="show" max-width="500" @input="(val) => outsideClick(val)">
    <v-card class="pt-4">
      <v-btn
        icon
        class="ml-4"
        color="primary"
        @click.stop="to($options.Steps.confirmation)"
      >
        <v-icon color="primary">mdi-arrow-left</v-icon>
      </v-btn>
      <CloseDialogButton :close="closeAuth" />
      <div class="align-center d-flex flex-column">
        <StorefrontImage class="display-none-height pt-10" size="large" />
        <Registration
          :registration="registration"
          :signUp="signUp"
          :updateRegistration="updateRegistration"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { Steps } from "@/types/signup.js";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import Registration from "@/components/Auth/SignUp/Content/Registration.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";

export default {
  name: "SignUpDialogRegistration",
  components: {
    CloseDialogButton,
    Registration,
    StorefrontImage,
  },
  props: {
    closeAuth: Function,
    outsideClick: Function,
    registration: Object,
    show: Boolean,
    signUp: Function,
    to: Function,
    updateRegistration: Function,
  },
  Steps,
};
</script>
<style scoped>
@media (max-height: 768px) {
  .display-none-height {
    display: none;
  }
}
</style>
